module.exports = __webpack_public_path__ + "polgenom_icon.png?72560bbfe29406dfadf8a81dfac96ddd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/polgenom_icon.png
// module id = 53
// module chunks = 0